import cn from "classnames";
import { useTranslation } from "react-i18next";

import { InvestObjectsHeaderProps } from "./InvestObjectsTabs.types";

import ChevronRightIcon from "assets/icons/chevron-right.svg?react";

import {
  CALCULATOR_OBJECT_TYPES,
  CALCULATOR_TYPES,
} from "constants/calculator";

import { getParkingTypeName } from "./InvestObjectsTabs.helpers";

import { Typography } from "shared/ui/components/Typography";

import styles from "./InvestObjectsTabs.module.scss";
import { getRentPerSqMeter } from "../InvestObjects/InvestObjects.helpers";

const InvestObjectsTabs = ({
  values,
  activeObject,
  calculatorType,
  onObjectClick,
}: InvestObjectsHeaderProps) => {
  const { t } = useTranslation();

  const isStandard = calculatorType === CALCULATOR_TYPES.BASIC;
  const activeObjectType = activeObject?.type;
  const activeObjectIndex = activeObject?.index;

  if (isStandard) {
    return null;
  }

  return (
    <div className={styles.root}>
      {values.apartments.map((apartment: any, index: number) => (
        <div
          key={`apartment-${apartment.id ?? index}`}
          className={cn(styles.item, {
            [styles.itemActive]:
              activeObjectType === CALCULATOR_OBJECT_TYPES.APARTMENT &&
              activeObjectIndex === index,
          })}
          onClick={() =>
            onObjectClick(CALCULATOR_OBJECT_TYPES.APARTMENT, index)
          }
        >
          <div className={styles.itemHeader}>
            <Typography variant="bodyM">
              {t("calculator_form.invest_objects.apartment")}
              {apartment.aptArea ? ` ${apartment.aptArea} m²` : ""}
              <Typography variant="bodyS" component="span">
                {apartment.aptArea ? ` (DIN277 ${apartment.aptArea}m²)` : ""}
              </Typography>
            </Typography>
            <ChevronRightIcon className={styles.itemIcon} name="chevronDown" />
          </div>

          <Typography
            variant="bodyXXS"
            component="span"
            className={styles.itemData}
          >
            Kaufpreis {apartment.aptPrice} €; mit Mögliche Steigerung{" "}
            {apartment.aptPriceGrowth} % alle{" "}
            {apartment.aptPriceGrowthDynamic.label};<br />
            Nettokaltmiete {apartment.aptRentPerMonth} € |{" "}
            {getRentPerSqMeter({
              aptRentPerMonth: apartment?.aptRentPerMonth,
              aptArea: apartment?.aptArea,
            })}
            ; mit Mögliche Steigerung {apartment.aptRentGrowth}% alle{" "}
            {apartment.aptRentGrowthDynamic.label};<br />
            Preisnachlass {apartment.aptDiscount} %; Preis für Möblierung{" "}
            {apartment.aptFurniturePrice} €; Grundstücksanteil{" "}
            {apartment.aptLandShare} %<br />
          </Typography>
        </div>
      ))}
      {values.parkings.map((parking: any, index: number) => (
        <div
          key={`parking-${parking.id ?? index}`}
          className={cn(styles.item, {
            [styles.itemActive]:
              activeObjectType === CALCULATOR_OBJECT_TYPES.PARKING &&
              activeObjectIndex === index,
          })}
          onClick={() => onObjectClick(CALCULATOR_OBJECT_TYPES.PARKING, index)}
        >
          <div className={styles.itemHeader}>
            <Typography variant="bodyM">
              {getParkingTypeName(parking.parkingType, t)}
              <Typography variant="bodyS" component="span">
                {parking.parkingDinSize
                  ? ` (DIN277 ${parking.parkingDinSize}m²)`
                  : ""}
              </Typography>
            </Typography>
            <ChevronRightIcon className={styles.itemIcon} name="chevronDown" />
          </div>
          <Typography
            variant="bodyXXS"
            component="span"
            className={styles.itemData}
          >
            Kaufpreis {parking.parkingPrice} €; mit Mögliche Steigerung{" "}
            {parking.parkingPriceGrowth} % alle{" "}
            {parking.parkingPriceGrowthDynamic.label};<br />
            Nettokaltmiete {parking.parkingRentPerMonth} € |{" "}
            {getRentPerSqMeter({
              aptRentPerMonth: parking?.parkingRentPerMonth,
              aptArea: parking?.parkingDinSize,
            })}
            ; mit Mögliche Steigerung {parking.parkingRentGrowth}% alle{" "}
            {parking.parkingRentGrowthDynamic.label};<br />
            Preisnachlass {parking.parkingDiscount} %; Preis für Möblierung{" "}
            {parking.parkingFurniturePrice} €; Grundstücksanteil{" "}
            {parking.parkingLandShare} %<br />
          </Typography>
        </div>
      ))}
    </div>
  );
};

export default InvestObjectsTabs;
